import { render, staticRenderFns } from "./ViewRequestsFilePage.vue?vue&type=template&id=43986a37&scoped=true&"
import script from "./ViewRequestsFilePage.vue?vue&type=script&lang=js&"
export * from "./ViewRequestsFilePage.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequestsFilePage.vue?vue&type=style&index=0&id=43986a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43986a37",
  null
  
)

export default component.exports